import SetupHome from "@/modules/setup/views/SetupHome"
import InsuranceTypesList from "@/modules/setup/views/InsuranceTypesList"
import InsuranceTypesCreate from "@/modules/setup/views/InsuranceTypesCreate"
import InsuranceTypesUpdate from "@/modules/setup/views/InsuranceTypesUpdate"
import InsurersList from "@/modules/setup/views/InsurersList"
import InsurersCreate from "@/modules/setup/views/InsurersCreate"
import InsurersUpdate from "@/modules/setup/views/InsurersUpdate"

export default [
	{
		path: "/:tenantId/setup",
		component: SetupHome,
		name: "SetupHome",
		meta: { featureId: "setup" },
		props: true
	},
	{
		path: "/:tenantId/setup/insurance-types",
		component: InsuranceTypesList,
		name: "InsuranceTypesList",
		props: true,
		meta: { featureId: "setup" }
	},
	{
		path: "/:tenantId/setup/insurance-types/create",
		component: InsuranceTypesCreate,
		name: "InsuranceTypesCreate",
		props: true,
		meta: { featureId: "setup" }
	},
	{
		path: "/:tenantId/setup/insurance-types/update/:id",
		component: InsuranceTypesUpdate,
		name: "InsuranceTypesUpdate",
		props: true,
		meta: { featureId: "setup" }
	},
	{
		path: "/:tenantId/setup/insurers",
		component: InsurersList,
		name: "InsurersList",
		props: true,
		meta: { featureId: "setup" }
	},
	{
		path: "/:tenantId/setup/insurers/create",
		component: InsurersCreate,
		name: "InsurersCreate",
		props: true,
		meta: { featureId: "setup" }
	},
	{
		path: "/:tenantId/setup/insurers/update/:id",
		component: InsurersUpdate,
		name: "InsurersUpdate",
		props: true,
		meta: { featureId: "setup" }
	}
]
